export const quickdashEn = {
  questions: [
    {
      promInstructions:
        "Please rate your ability to do the following activity in the last week:",
      scaleStartLabel: "No Difficulty",
      scaleEndLabel: "Unable",
      scaleLabels: [
        "No Difficulty",
        "Mild Difficulty",
        "Moderate Difficulty",
        "Severe Difficulty",
        "Unable",
      ],
      text: "Open a tight or new jar",
    },
    {
      promInstructions:
        "Please rate your ability to do the following activity in the last week:",
      scaleStartLabel: "No Difficulty",
      scaleEndLabel: "Unable",
      scaleLabels: [
        "No Difficulty",
        "Mild Difficulty",
        "Moderate Difficulty",
        "Severe Difficulty",
        "Unable",
      ],
      text: "Do heavy household chores (e.g., wash walls, floors)",
    },
    {
      promInstructions:
        "Please rate your ability to do the following activity in the last week:",
      scaleStartLabel: "No Difficulty",
      scaleEndLabel: "Unable",
      scaleLabels: [
        "No Difficulty",
        "Mild Difficulty",
        "Moderate Difficulty",
        "Severe Difficulty",
        "Unable",
      ],
      text: "Carry a shopping bag or briefcase",
    },
    {
      promInstructions:
        "Please rate your ability to do the following activity in the last week:",
      scaleStartLabel: "No Difficulty",
      scaleEndLabel: "Unable",
      scaleLabels: [
        "No Difficulty",
        "Mild Difficulty",
        "Moderate Difficulty",
        "Severe Difficulty",
        "Unable",
      ],
      text: "Wash your back",
    },
    {
      promInstructions:
        "Please rate your ability to do the following activity in the last week:",
      scaleStartLabel: "No Difficulty",
      scaleEndLabel: "Unable",
      scaleLabels: [
        "No Difficulty",
        "Mild Difficulty",
        "Moderate Difficulty",
        "Severe Difficulty",
        "Unable",
      ],
      text: "Use a knife to cut food",
    },
    {
      promInstructions:
        "Please rate your ability to do the following activity in the last week:",
      scaleStartLabel: "No Difficulty",
      scaleEndLabel: "Unable",
      scaleLabels: [
        "No Difficulty",
        "Mild Difficulty",
        "Moderate Difficulty",
        "Severe Difficulty",
        "Unable",
      ],
      text: "Recreational activities in which you take some force or impact through your arm, shoulder or hand. (e.g., golf, hammering, tennis, etc.)",
    },
    {
      promInstructions: "During the past week:",
      scaleStartLabel: "None",
      scaleEndLabel: "Extreme",
      scaleLabels: [
        "Not at All",
        "Slightly",
        "Moderately",
        "Quite a Bit",
        "Extremely",
      ],
      text: "To what extent has your arm, shoulder or hand problem interfered with your normal social activities with family, friends, neighbors or groups?",
    },
    {
      promInstructions: "During the past week:",
      scaleStartLabel: "No Limit",
      scaleEndLabel: "Unable",
      scaleLabels: [
        "Not limited at all",
        "Slightly limited",
        "Moderately limited",
        "Very limited",
        "Unable",
      ],
      text: "Were you limited in your work or other regular daily activities as a result of your arm, shoulder or hand problem?",
    },
    {
      promInstructions:
        "Please rate the severity of the symptoms in the last week:",
      scaleStartLabel: "None",
      scaleEndLabel: "Extreme",
      scaleLabels: ["None", "Mild", "Moderate", "Severe", "Extreme"],
      text: "Arm, shoulder or hand pain",
    },
    {
      promInstructions:
        "Please rate the severity of the symptoms in the last week:",
      scaleStartLabel: "None",
      scaleEndLabel: "Extreme",
      scaleLabels: ["None", "Mild", "Moderate", "Severe", "Extreme"],
      text: "Tingling (pins and needles) in your arm, shoulder or hand",
    },
    {
      promInstructions: "During the past week:",
      scaleStartLabel: "No Difficulty",
      scaleEndLabel: "Can't Sleep",
      scaleLabels: [
        "No Difficulty",
        "Mild Difficulty",
        "Moderate Difficulty",
        "Severe Difficulty",
        "So much difficulty that I can't sleep",
      ],
      text: "How much difficulty have you had sleeping because of pain in your arm, shoulder or hand?",
    },
  ],
};
